import { CaseOptions } from 'constants/enums/options';

export const defaultCaseOptions = [
  {
    label: 'common.terms.selectAll',
    value: CaseOptions.SelectAll,
  },
  {
    label: 'common.actions.activateAll',
    value: CaseOptions.ActivateAll,
  },
  {
    label: 'common.actions.deactivateAll',
    value: CaseOptions.DeactivateAll,
  },
  {
    label: 'common.actions.downloadZip',
    value: CaseOptions.Download,
  },
  {
    label: 'common.actions.copyAssets',
    value: CaseOptions.CopyAssets,
  },
  {
    label: 'materials.actions.removeBatch',
    value: CaseOptions.RemoveBatch,
  },
];

export const interiorOptions = [
  '',
  'INTERIOR_DESIGN_SUGGESTION',
  'FACADE_SUGGESTION',
  'ILLUSTRATION_IMAGE',
  'STYLING_SUGGESTION',
  'ALTERNATIVE_DECOR',
  'SUGGESTION',
];
